import { createReducer } from 'redux-act';
import {requestPillarEmotionFrequencyData, responsePillarEmotionFrequencyData} from './action';


const defaultState = {
	requestProcess: false,
};

const reducer = createReducer({

	[requestPillarEmotionFrequencyData]: (state) => {
    return {
      requestProcess: true,
	  	data: [],
    };
  },

  [responsePillarEmotionFrequencyData]: (state, params) => {
		return {
			requestProcess: false,
			data: params,
		};
	},


}, defaultState);



export default reducer
